<template>
  <div v-if="posterImageStatus" class="poster-first">
    <div class="poster-pop" style="width:6rem;left:42%;" v-show="!canvasStatus && posterImage">

      <img
              :src="posterImage"
              ref="conf0"
              alt="tp"
              class="poster-image"
              id="scream"
              style="border-radius: .15rem;"
      />
      <div class="preserve acea-row row-center-wrapper">
        <div class="line"></div>
        <div class="tip">长按保存图片</div>
        <div class="line"></div>
      </div>
    </div>
    <div class="mask" style="background-color:#a3a3a3;" ></div>
    <div class="canvasBox">
      <canvas ref="myCanvas" width="750" height="1288"></canvas>
    </div>
    <div id="bicode" style="display:none;">
      <vue-qr  :text="posterData.url"  :size="200"></vue-qr>
    </div>


  </div>

</template>
<script>
  import {getSpreadImg} from "../../../api/user";
  import vueQr from 'vue-qr';
  export default {
    name: "StorePoster",

    data: function() {
      return {
        canvasStatus: false,
        posterImage: "",
        posterData: {
          image: "",
          title: "",
          nickname: "",
          code: "",
          url:"",
          bg_url:'',
        },
        posterImageStatus:true,
      };
    },
    watch: {
      /*posterImageStatus: function() {
        let that = this;
        if (that.posterImageStatus === true) {
          that.$nextTick(function() {
            that.savePosterPath();
          });
        }
      }*/
    },
    components: {
      vueQr
    },
    mounted: function() {
      this.getIndex();
      //获取二维码

    },
    methods: {

      getIndex: function() {
        let that = this;
        this.$dialog.loading.open();
        getSpreadImg().then(
                res => {

                  that.posterData.nickname = res.data.nickname;
                  that.posterData.url = res.data.url;
                  that.posterData.code = res.data.code;
                  that.posterData.title = '邀请您加入'+res.data.site_name;
                  that.posterData.image = res.data.img;//

                  that.savePosterPath();
                },
                err => {
                  that.$dialog.message(err.msg);
                }
        );
      },
      posterImageClose: function() {
        this.posterImageStatus = false;
        this.canvasStatus = false;
        this.$emit("setPosterImageStatus");
      },
      savePosterPath: function() {

        this.setHtml2Canvas();
      },
      setHtml2Canvas: function() {
        let title = this.posterData.title;
        let nickname = this.posterData.nickname;
        let that = this;

        const canvas = document.createElement("canvas");
        let _ix = 750;
        let _iy = 1250;
        canvas.width = _ix;
        canvas.height = _iy;

        const img = new Image();
        img.src = this.posterData.image;

        img.onload = function () {

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, 750, 1250);

          var screamsCode = new Image();
          var src = document.getElementById('bicode').getElementsByTagName('img')[0].src;

          screamsCode.src = src;

          screamsCode.onload = function() {
            ctx.drawImage(screamsCode, 100, 970, 200, 200);
            ctx.font = "30px Microsoft Yahei";
            ctx.textAlign = "left";
            ctx.textBaseline = "Middle";
            ctx.fillStyle = "#000";
            ctx.fillText(nickname, 320, 1030);

            ctx.font = "30px Microsoft Yahei";
            ctx.textAlign = "left";
            ctx.textBaseline = "Middle";
            ctx.fillStyle = "#000";
            ctx.fillText(title,320, 1080);

            that.posterImage = canvas.toDataURL();
            that.$dialog.loading.close();
          };
        }



        /*var img = new Image();
        let imgY = 1250
        img.src = this.posterData.image;
        img.crossOrigin = "anonymous";
        img.onload = function() {
          var c = this.$refs.myCanvas;
          var ctx = c.getContext("2d");
          var imageData = ctx.getImageData(0, 0, c.width, c.height);
          for (var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的,则设置成白色
            if (imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          ctx.drawImage(img, 0, 0, 750, imgY);


          ctx.font = "36px Arial";
          ctx.fillStyle = "#000";
          ctx.textAlign = "left";
          ctx.fillText(this.posterData.nickname, 330, 1050);*/

          /*ctx.font = "36px Arial";
          ctx.fillStyle = "#000";
          ctx.position="relative";
          ctx.textAlign = "left";
          ctx.fillText(this.posterData.title,330, 1120);

        };*/




/*
        var screamsCode = new Image();
        screamsCode.onload = function() {
          ctx.drawImage(screamsCode, 100, 970, 200, 200);
        };
        screamsCode.src = this.posterData.code;*/


        /*setTimeout(() => {
          this.posterImage = canvas.toDataURL();
          this.$dialog.loading.close();
        }, 500);*/
      },
      /**
       * str:要绘制的字符串
       * canvas:canvas对象
       * initX:绘制字符串起始x坐标
       * initY:绘制字符串起始y坐标
       * lineHeight:字行高，自己定义个值即可
       * canvasWidth:文本宽度
       * lines: 行数
       */
      canvasTextAutoLine(
              str,
              canvas,
              initX,
              initY,
              lineHeight,
              canvasWidth,
              lines
      ) {
        var ctx = canvas.getContext("2d");
        var lineWidth = 0;
        var lastSubStrIndex = 0;
        var beginLineHeight = lineHeight;
        var beginY = initY;
        for (let i = 0; i < str.length; i++) {
          lineWidth += ctx.measureText(str[i]).width;
          if (lineWidth > canvasWidth - initX) {
            //减去initX,防止边界出现的问题
            if (initY >= beginY + beginLineHeight * (lines - 1)) {
              ctx.fillText(
                      str.substring(lastSubStrIndex, i - 1) + "...",
                      initX,
                      initY
              );
              return;
            } else {
              ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY);
              initY += lineHeight;
              lineWidth = 0;
              lastSubStrIndex = i;
            }
          }
          if (i == str.length - 1) {
            ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY);
          }
        }
      }
    }
  };
</script>
<style>

  .preserve {
    color: #fff;
    text-align: center;
    margin-top: 0.2rem;
  }
  .preserve .line {
    width: 1rem;
    height: 0.01rem;
    background-color: #fff;
  }
  .preserve .tip {
    margin: 0 0.3rem;
  }
</style>
<style scoped>
.qrcode1{
  display: inline-block;

}
.qrcode1 img {
  width: 132px;
  height: 132px;
  background-color: #fff;
padding: 6px;
box-sizing: border-box;
}
  .poster-first .mask {
    z-index: 1001 !important;
  }
  .canvasBox {
    width: 100%;
    height: 100%;
    margin: auto;
    /*display: flex;*/
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: none;
  }
  .poster-first {
    overscroll-behavior: contain;
  }
  .poster-pop {
    width: 4.8rem;
    position: fixed;
    left: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    z-index: 9999;
    top: 50%;
    margin-left: -2.4rem;
  }
  .poster-pop .canvas {
    background-color: #ffffff;
    width: 100%;
  }
  .poster-pop .poster-image {
    width: 100%;
    display: block;
  }
  .poster-pop .canvas .image {
    width: 100%;
    height: 4.5rem;
    display: block;
  }
  .poster-pop .canvas .text {
    text-align: center;
    margin-top: 0.32rem;
  }
  .poster-pop .canvas .text.black {
    padding: 0 0.1rem;
    color: #000;
  }
  .poster-pop .canvas .text.rad {
    color: #ff0000;
  }
  .poster-pop .canvas .code {
    padding: 0 0.1rem 0.2rem 0.1rem;
  }
  .poster-pop .canvas .code .code-img {
    width: 1.7rem;
    height: 1.7rem;
  }
  .poster-pop .canvas .code .code-img img {
    width: 100%;
    height: 100%;
  }
  .poster-pop .canvas .code .code-text {
    width: 2.8rem;
    font-size: 0.24rem;
  }
  .poster-pop .close {
    width: 0.46rem;
    height: 0.75rem;
    position: fixed;
    right: 0;
    top: -0.75rem;
    display: block;
  }
  .keep {
    color: #fff;
    text-align: center;
    font-size: 0.25rem;
    margin-top: 0.1rem;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9;
  }
  img {
    border: none;
  }
</style>
